<template>
    <select :value="value" @input="$emit('input', $event.target.value)" class="form-control">
        <option :value="null">--Select State--</option>
        <option :key="state.code" :value="state.code" v-for="state in states">{{ state.name }}</option>
    </select>
</template>

<script>
    import LocationService from "@/services/LocationService";

    export default {
        props: {
            value: {
                required: false,
                type: String
            }
        },
        data() {
            return {
                states: []
            };
        },
        created() {
            this.states = LocationService.getStates();
        }
    };
</script>

